import moment from 'moment';

export default class SimulationReportNotification {
  constructor(data) {
    this.Source = data.Source;
    this.Type = data.Type;
    this.Message = data.Message;
    this.TriggeredCandleId = data.TriggeredCandleId;
    this.TickerId = data.TickerId;

    // Handle Time field with moment.js - same pattern as other entities
    if (data.Time !== undefined) {
      this.Time = (data.Time === null) ? null : moment.utc(data.Time);
    }

    // Handle TriggeredCandleTime field with moment.js
    if (data.TriggeredCandleTime !== undefined) {
      this.TriggeredCandleTime = (data.TriggeredCandleTime === null) ? null : moment.utc(data.TriggeredCandleTime);
    }
  }

  // Return formatted local time string for display
  getTime() {
    return this.Time ? this.Time.local().format('L LTS') : '';
  }

  // Return formatted triggered candle time for display
  getTriggeredCandleTime() {
    return this.TriggeredCandleTime ? this.TriggeredCandleTime.local().format('L LTS') : '-';
  }

  // Get ticker display - return TickerId or dash if not available
  getTickerDisplay() {
    return this.TickerId || '-';
  }

  // Get type display
  getTypeDisplay() {
    return this.Type || '-';
  }

  // Get message display
  getMessageDisplay() {
    return this.Message || '';
  }
}